import { useEffect, useMemo, useRef, useState } from 'react';
import { debounce } from 'throttle-debounce';
export const useDebounceState = (defaultValue, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(defaultValue);
    const cancelRef = useRef();
    useEffect(() => () => { var _a; return (_a = cancelRef.current) === null || _a === void 0 ? void 0 : _a.cancel(); }, []);
    const setValue = useMemo(() => (cancelRef.current = debounce(delay, (newValue) => {
        setDebouncedValue(newValue);
    })), [delay]);
    return [debouncedValue, setValue];
};
//# sourceMappingURL=useDebounceState.js.map